module.exports = __webpack_public_path__ + "img/add.b6b6f572.svg";